const flatElements = (src, dest) => {
  src.forEach(o => {
    if (o.transition) dest.push(o);
    if (o.conf && o.conf.length > 0) {
      flatElements(o.conf, dest);
    }
  });
};

export default flatElements;



// WEBPACK FOOTER //
// ./src/store/flatElements.js